export default "__VITE_ASSET__vpos_hU6__"